// extracted by mini-css-extract-plugin
export var messageSideLeft = "_t5-1";
export var stateContainer = "_t5-0";